import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  children: PropTypes.node,
}

const Container = props => {
  return (
    <div className="container relative mx-auto px-6 lg:px-12 xl:px-6 xl:max-w-screen-xl xxl:max-w-screen-xxl">
      {props.children}
    </div>
  )
}

Container.propTypes = propTypes

export default Container
